/*
 * @Author: wangyan1
 * @Description:
 * @Date:  2022-04-22 15:19:00
 * @LastEditTime: 2022-07-25 15:26:10
 * @FilePath: /teacher-xkh-web/src/service/groupManage/index.js
 */
import http from '../http'
import url from './index-url'
const { post } = http

export default {
  // 我的小组
  getGroupList(data) {
    return post(url.getGroupList, data)
  },
  // 组内学生列表
  getIntragroupStudent(data) {
    return post(url.getIntragroupStudent, data)
  },
  // 学生作业订正数据
  getStudentCorrection(data) {
    return post(url.getStudentCorrection, data)
  },
  // 新增学员
  addNewStudent(data) {
    return post(url.addNewStudent, data)
  },
  // 学员详情讲次列表
  getStudentLessons(data) {
    return post(url.getStudentLessons, data)
  },
  // 学员详情讲次列表
  getStudentPathlog(data) {
    return post(url.getStudentPathlog, data)
  },
  // 隐藏小组
  hideGroup(data) {
    return post(url.hideGroup(data), data)
  }
}